<template>
  <div class="card-container">
    <div class="card">
      <div class="card-title">新增收入</div>
      <div class="card-data">
        {{ Number(data?.addAmount ?? 0).toFixed(0) }}<span>元</span>
      </div>
      <div class="card-rate">
        <span v-if="data?.addRatio > 0" style="color: #f53f3f"
          >+{{ Number(data?.addRatio).toFixed(1) }}%</span
        >
        <span v-else-if="data?.addRatio < 0"
          >{{ Number(data?.addRatio).toFixed(1) }}%</span
        >
        <img
          v-if="data?.addRatio > 0"
          class="decreaseIcon"
          :src="increaseImg"
          alt=""
          srcset=""
        />
        <img
          v-if="data?.addRatio < 0"
          class="decreaseIcon"
          :src="decreaseImg"
          alt=""
          srcset=""
        />
      </div>
    </div>
    <div class="card">
      <div class="card-title">订阅收入</div>
      <div class="card-data">
        {{ Number(data?.subscribeAmount ?? 0).toFixed(0) }}<span>元</span>
      </div>
      <div class="card-rate">
        <span v-if="data?.subscribeRatio > 0" style="color: #f53f3f"
          >+{{ Number(data?.subscribeRatio).toFixed(1) }}%</span
        >
        <span v-else-if="data?.subscribeRatio < 0"
          >{{ Number(data?.subscribeRatio).toFixed(1) }}%</span
        >
        <img
          v-if="data?.subscribeRatio > 0"
          class="decreaseIcon"
          :src="increaseImg"
          alt=""
          srcset=""
        />
        <img
          v-if="data?.subscribeRatio < 0"
          class="decreaseIcon"
          :src="decreaseImg"
          alt=""
          srcset=""
        />
      </div>
    </div>
    <div class="card">
      <div class="card-title">购买会员收入</div>
      <div class="card-data">
        {{ Number(data?.buyAmount ?? 0).toFixed(0) }}<span>元</span>
      </div>
      <div class="card-rate">
        <span v-if="data?.buyRatio > 0" style="color: #f53f3f"
          >+{{ Number(data?.buyRatio).toFixed(1) }}%</span
        >
        <span v-else-if="data?.buyRatio < 0"
          >{{ Number(data?.buyRatio).toFixed(1) }}%</span
        >
        <img
          v-if="data?.buyRatio > 0"
          class="decreaseIcon"
          :src="increaseImg"
          alt=""
          srcset=""
        />
        <img
          v-if="data?.buyRatio < 0"
          class="decreaseIcon"
          :src="decreaseImg"
          alt=""
          srcset=""
        />
      </div>
    </div>
    <div class="card">
      <div class="card-title">兑换会员数</div>
      <div class="card-data">
        {{ Number(data?.exchangeVipNum ?? 0).toFixed(0) }}<span>次</span>
      </div>
      <div class="card-rate">
        <span v-if="data?.exchangeVipRatio > 0" style="color: #f53f3f"
          >+{{ Number(data?.exchangeVipRatio).toFixed(1) }}%</span
        >
        <span v-else-if="data?.exchangeVipRatio < 0"
          >{{ Number(data?.exchangeVipRatio).toFixed(1) }}%</span
        >
        <img
          v-if="data?.exchangeVipRatio > 0"
          class="decreaseIcon"
          :src="increaseImg"
          alt=""
          srcset=""
        />
        <img
          v-if="data?.exchangeVipRatio < 0"
          class="decreaseIcon"
          :src="decreaseImg"
          alt=""
          srcset=""
        />
      </div>
    </div>
    <div class="card-b">
      <div class="card-title">新增会员数</div>
      <div class="card-data">
        {{ Number(data?.addVipNum ?? 0).toFixed(0) }}<span>人</span>
      </div>
      <div class="card-rate">
        <span v-if="data?.addVipRatio > 0" style="color: #f53f3f"
          >+{{ Number(data?.addVipRatio).toFixed(1) }}%</span
        >
        <span v-else-if="data?.addVipRatio < 0"
          >{{ Number(data?.addVipRatio).toFixed(1) }}%</span
        >
        <img
          v-if="data?.addVipRatio > 0"
          class="decreaseIcon"
          :src="increaseImg"
          alt=""
          srcset=""
        />
        <img
          v-if="data?.addVipRatio < 0"
          class="decreaseIcon"
          :src="decreaseImg"
          alt=""
          srcset=""
        />
      </div>
    </div>
    <div class="card-b">
      <div class="card-title">新增订阅会员数</div>
      <div class="card-data">
        {{ Number(data?.addSubVipNum ?? 0).toFixed(0) }}<span>次</span>
      </div>
      <div class="card-rate">
        <span v-if="data?.addSubVipRatio > 0" style="color: #f53f3f"
          >+{{ Number(data?.addSubVipRatio).toFixed(1) }}%</span
        >
        <span v-else-if="data?.addSubVipRatio < 0"
          >{{ Number(data?.addSubVipRatio).toFixed(1) }}%</span
        >
        <img
          v-if="data?.addSubVipRatio > 0"
          class="decreaseIcon"
          :src="increaseImg"
          alt=""
          srcset=""
        />
        <img
          v-if="data?.addSubVipRatio < 0"
          class="decreaseIcon"
          :src="decreaseImg"
          alt=""
          srcset=""
        />
      </div>
    </div>
    <div class="card-b">
      <div class="card-title">购买会员数</div>
      <div class="card-data">
        {{ Number(data?.buyAmount ?? 0).toFixed(0) }}<span>次</span>
      </div>
      <div class="card-rate">
        <span v-if="data?.buyRatio > 0" style="color: #f53f3f"
          >+{{ Number(data?.buyRatio).toFixed(1) }}%</span
        >
        <span v-else-if="data?.buyRatio < 0"
          >{{ Number(data?.buyRatio).toFixed(1) }}%</span
        >
        <img
          v-if="data?.buyRatio > 0"
          class="decreaseIcon"
          :src="increaseImg"
          alt=""
          srcset=""
        />
        <img
          v-if="data?.buyRatio < 0"
          class="decreaseIcon"
          :src="decreaseImg"
          alt=""
          srcset=""
        />
      </div>
    </div>
    <div class="card-b">
      <div class="card-title">领取会员数</div>
      <div class="card-data">
        {{ Number(data?.giftVipNum ?? 0).toFixed(0) }}<span>次</span>
      </div>
      <div class="card-rate">
        <span v-if="data?.giftVipRatio > 0" style="color: #f53f3f"
          >+{{ Number(data?.giftVipRatio).toFixed(1) }}%</span
        >
        <span v-else-if="data?.giftVipRatio < 0"
          >{{ Number(data?.giftVipRatio).toFixed(1) }}%</span
        >
        <img
          v-if="data?.giftVipRatio > 0"
          class="decreaseIcon"
          :src="increaseImg"
          alt=""
          srcset=""
        />
        <img
          v-if="data?.giftVipRatio < 0"
          class="decreaseIcon"
          :src="decreaseImg"
          alt=""
          srcset=""
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {},
  },
  data() {
    return {
      increaseImg: require("@/assets/images/increase@2x.png"),
      decreaseImg: require("@/assets/images/decrease@2x.png"),
    };
  },
  methods: {},
};
</script>

<style scoped lang="less">
.card-container {
  display: flex;
  flex-wrap: wrap; /* 允许换行 */
  justify-content: space-between; /* 卡片之间的间距 */
}
.card {
  width: calc(25% - 10px); /* 每个卡片的宽度占四分之一减去间距 */
  margin-bottom: 50px; /* 卡片之间的垂直间距 */
}
.card-b {
  width: calc(25% - 10px); /* 每个卡片的宽度占四分之一减去间距 */
  margin-bottom: 0px; /* 卡片之间的垂直间距 */
}
.card-title {
  font-weight: 400;
  font-size: 14px;
  color: #4e5969;
  margin-bottom: 8px;
}
.card-data {
  font-weight: 400;
  font-size: 24px;
  color: #1d2129;
  margin-bottom: 12px;
  span {
    font-weight: 500;
    font-size: 14px;
    color: #1d2129;
    margin-left: 4px;
  }
}
.card-rate {
  font-weight: 400;
  font-size: 14px;
  color: #00b42a;
}
.decreaseIcon {
  width: 12px;
  height: 12px;
  margin-left: 4px;
}
</style>
